/**
 * This is a wrapper component for different Layouts.
 * TopBar should be added to this wrapper.
 */
import { Box } from '@mui/material';
import React, { memo } from 'react';

const rootSx = (theme) => ({
  width: '100%',
  position: 'sticky',
  top: 0,
  zIndex: theme.tokens.zIndexTopbar,
});

/**
 * @typedef {object} LayoutWrapperTopbarProps
 * @property {string | null} [className] - Additional class to be added to the root element.
 * @property {string | null} [rootClassName] - Additional class to be added to the root element.
 * @property {React.JSX.Element} children - Collection of children to be rendered.
 */

const LayoutWrapperTopbarComponent = ({ className = null, rootClassName = null, children }) => (
  <Box className={className || undefined} sx={rootClassName ? undefined : rootSx}>
    {children}
  </Box>
);

LayoutWrapperTopbarComponent.displayName = 'LayoutWrapperTopbar';

const LayoutWrapperTopbar = memo(LayoutWrapperTopbarComponent);

export default LayoutWrapperTopbar;
